export default __webpack_public_path__ + "static/media/320D.f67e1e17.pdf";